import React from "react";
import { Modal, Button } from "react-bootstrap";

interface ResponseType {
  status: "success" | "error";
  message: string;
}

interface ResponseModalProps {
  show: boolean;
  onClose: () => void;
  response: ResponseType | null;
}

const ResponseModal: React.FC<ResponseModalProps> = ({ show, onClose, response }) => {
  if (!response) return null;

  const isSuccess = response.status === "success";
  const iconClass = isSuccess ? "bi bi-check-circle-fill text-success" : "bi bi-x-circle-fill text-danger";
  const bgClass = isSuccess ? "bg-success-light" : "bg-danger-light";

  return (
    <Modal show={show} onHide={onClose} centered>
      <div className="modal-body">
        <div className="text-center">
          <div className={`avatar avatar-xl ${bgClass} rounded-circle mb-3`}>
            <i className={`${iconClass} fs-36`} />
          </div>
          <h4 className="mb-2">{isSuccess ? "Success!" : "Error!"}</h4>
          <p className="mb-0">{response.message || "Something went wrong!"}</p>
          <div className="d-flex align-items-center justify-content-center mt-4">
            <Button variant="light" onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ResponseModal;
